import client from "./client";
import endPoints from "./endPoints";

export const _plansListing = async (payload) => {
  return await client.get(`${endPoints.PLAN_LISTING}`, payload);
};

export const _subscribePlan = async (id) => {
  return await client.get(`${endPoints.SUBSCRIBE_PLAN}?plan_id=${id}`);
};

export const _subscribeFreePlan = async () => {
  return await client.get(`${endPoints.SUBSCRIBE_FREE_PLAN}`);
};

export const _subscribeSuccess = async (id) => {
  return await client.get(`${endPoints.SUBSCRIBE_SUCCESS}?plan_id=${id}`);
};

export const _subscribeCancel = async (id) => {
  return await client.get(`${endPoints.SUBSCRIBE_CANCEL}?plan_id=${id}`);
};

export const getAllNumberOfUsersForTheCurrentPlan = async () => {
  return await client.get();
};
export const addNewUserForTheCurrentPlan = async ({ payload }) => {
  return await client.post();
};
export const updateUserForTheCurrentPlan = async ({ id, payload }) => {
  return await client.put();
};
export const deleteUserForTheCurrentPlan = async ({ id }) => {
  return await client.delete();
};
export const onSubscribeNowRequest = async () => {
  return await client.get();
};
export const onCancelCurrentSubscriptionPlan = async ({ id }) => {
  return await client.delete(`/organizations/subscriptions/${id}`);
};
export const getMyOrganization = async () => {
  return await client.get("organizations");
};
export const addUserToMyOrganization = async ({ payload }) => {
  return await client.post("/organizations/examiners", payload);
};
export const updateUserInMyOrganization = async ({ payload }) => {
  return await client.put("/organizations/examiners", payload);
};
export const deleteUserFromMyOrganization = async ({ id }) => {
  return await client.delete(`/organizations/examiners/${id}`);
};
export const deactivateUserInMyOrganization = async ({ payload }) => {
  return await client.put("/organizations/examiners", payload);
};
export const increaseSeatsForMyOrganization = async ({ payload }) => {
  return await client.put("/organizations/seats", payload);
};
export const getBellingSession = async ({ returnUrl }) => {
  return await client.get(
    `/organizations/billing-session-url?return_url=${returnUrl}`
  );
};

export const getUpgradeSubscriptionInvoice = async () => {
  return await client.get("organizations/subscriptions/upgrade");
};
export const getUpgradeSeatsInvoice = async ({ seats }) => {
  return await client.get(`organizations/seats?no_of_seats=${seats}`);
};

export const upgradeSubscriptionToYearly = async () => {
  return await client.post("organizations/subscriptions/upgrade");
};

export const getDentalIdPricingTable = async () => {
  return await client.get("organizations/subscriptions/subscribe");
};
export const onSubscribeDentalIdPlan = async ({ payload }) => {
  return await client.post("organizations/subscriptions/subscribe", payload);
};
